import { isLiveChat } from 'util/chat';
import * as orderSearchOptions from '../constants/searchActions';
import first from 'lodash/first';
import { isSpecialist } from '../extractFromState';

/*
Functions that choose a default value based on available options
 */

export const chooseOrderingSystemForSelectedAction = (selectedSearchAction) => {
  // TODO: Add UI for expert to select ordering system and 'search by' separately
  if (
    [
      orderSearchOptions.COMMON_ORDER_EMAIL,
      orderSearchOptions.COMMON_ORDER_NUMBER,
      orderSearchOptions.COMMON_ORDER_PHONE_NUMBER,
      orderSearchOptions.COMMON_ORDER_DYNAMIC_INPUT_0,
      orderSearchOptions.COMMON_ORDER_DYNAMIC_INPUT_1,
      orderSearchOptions.COMMON_ORDER_DYNAMIC_INPUT_2,
    ].includes(selectedSearchAction)
  ) {
    return 'common';
  } else if (
    [
      orderSearchOptions.SHOPIFY_ORDER_NUMBER,
      orderSearchOptions.SHOPIFY_FULL_NAME,
      orderSearchOptions.SHOPIFY_EMAIL,
      orderSearchOptions.SHOPIFY_PHONE_NUMBER,
      orderSearchOptions.ZENDESK_EBAY_USERNAME,
      orderSearchOptions.ZENDESK_EMAIL,
      orderSearchOptions.ZENDESK_FULL_NAME,
      orderSearchOptions.ZENDESK_ORDER_NUMBER,
    ].includes(selectedSearchAction)
  ) {
    return 'shopify';
  } else if ([orderSearchOptions.AMAZON_EMAIL, orderSearchOptions.AMAZON_ORDER_NUMBER].includes(selectedSearchAction)) {
    return 'amazon';
  } else if ([orderSearchOptions.CUSTOM_SELLER_EMAIL].includes(selectedSearchAction)) {
    return 'customSeller';
  } else if (
    [
      orderSearchOptions.SIMPLR_ORDER_ID,
      orderSearchOptions.SIMPLR_ORDER_EMAIL,
      orderSearchOptions.SIMPLR_ORDER_PHONE_NUMBER,
      orderSearchOptions.SIMPLR_ORDER_CUSTOMER_NAME,
      orderSearchOptions.SIMPLR_ORDER_CUSTOMER_ID,
      orderSearchOptions.SIMPLR_ORDER_SUBSCRIPTION_EMAIL,
    ].includes(selectedSearchAction)
  ) {
    return 'simplrOrder';
  } else if (
    [orderSearchOptions.RBI_EMAIL, orderSearchOptions.RBI_ID, orderSearchOptions.RBI_CARD_ID].includes(
      selectedSearchAction
    )
  ) {
    return 'custom_rbi';
  } else if (
    [orderSearchOptions.SALESFORCE_ORDER_EMAIL, orderSearchOptions.SALESFORCE_ORDER_ID].includes(selectedSearchAction)
  ) {
    return 'salesforce';
  } else if (
    [orderSearchOptions.BIG_COMMERCE_ORDER_EMAIL, orderSearchOptions.BIG_COMMERCE_ORDER_ID].includes(
      selectedSearchAction
    )
  ) {
    return 'bigCommerce';
  } else if (
    [orderSearchOptions.REVOLVE_ORDER_EMAIL, orderSearchOptions.REVOLVE_ORDER_ID].includes(selectedSearchAction)
  ) {
    return 'revolve';
  }
};

export const chooseDefaultNominatedTicket = (state) => {
  return first(state.tickets.nominatedTickets.allTickets);
};

export const chooseDefaultAssignedTicket = (state) => {
  const assignedTickets = state.tickets.assignedTickets.allTickets.map((id) => state.tickets.assignedTickets[id]);
  const nonLiveChatTickets = assignedTickets.filter(({ communicationType }) => !isLiveChat(communicationType));

  return first(
    isSpecialist(state)
      ? assignedTickets.map(({ ticketId }) => ticketId)
      : nonLiveChatTickets.map(({ ticketId }) => ticketId)
  );
};

export const chooseDefaultLiveChatTicket = (state) => {
  if (isSpecialist(state)) {
    throw new Error('should not be called by admin');
  }
  const assignedTickets = state.tickets.assignedTickets.allTickets.map((id) => state.tickets.assignedTickets[id]);
  const liveChatTickets = assignedTickets.filter(({ communicationType }) => isLiveChat(communicationType));

  return first(liveChatTickets.map(({ ticketId }) => ticketId));
};

export const chooseDefaultAllTicketId = (state) => {
  return first(state.tickets.allTickets.allTickets);
};

// TODO: refactor - use getDefaultTicket from extractFromState instead of chooseDefaultTicket everywhere
// choose ticketId based on available tickets
export const chooseDefaultTicket = (selectedTab, state) => {
  switch (selectedTab) {
    case 'nominated':
      return chooseDefaultNominatedTicket(state);
    case 'assigned':
      return chooseDefaultAssignedTicket(state);
    case 'live_chat':
      return chooseDefaultLiveChatTicket(state);
    case 'all':
      return chooseDefaultAllTicketId(state);

    default:
      throw new Error(`unknown selectedInboxTab ${selectedTab}`);
  }
};
